module.exports = __webpack_public_path__ + "a09763afa0b8d61bd334eda895e08c19.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-3.png
// module id = 2920
// module chunks = 0